import { Getter } from 'vuex'
import { UserState } from '../types'
import { RootState } from '@/store/types'

const getUserActiveTo: Getter<UserState, RootState> = (state) => {
  return state.current?.active_to || ''
}

export default getUserActiveTo
